export default {
  data: function data() {
    return {
      isOpen: false,
      currentObject: {},
      items: [],
      position: {
        x: null,
        y: null
      }
    };
  },
  methods: {
    openMenu: function openMenu(object, items, position) {
      this.isOpen = true;
      this.currentObject = object;
      this.items = items;
      this.position = position;
    },
    itemClicked: function itemClicked(idItem) {
      this.$emit("contextMenuItemClicked", {
        object: this.currentObject,
        idItem: idItem
      });
    }
  }
};